import { useState } from 'react';
import { RepairsPage, RepairsHeader } from './RepairsComponents';
import { RepairsGroupBody } from './RepairsGroupComponents';
import { RoleGuard } from '../../routes';
import { RepairCreateInvoiceModal, RepairSetUpdateMultipleModal } from '../../design-system';

export const RepairsGroup = () => {
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [checkIndexs, setCheckIndexs] = useState<number[]>([]);
  const [onAddRepairClick, setOnAddRepairClick] = useState<(() => void) | undefined>();

  const handleCheckboxChange = (i: number) => {
    if (isNaN(i)) {
      const allCheckIndexs = Array.from({ length: data.length }, (_, i) => i);
      setCheckIndexs(checkIndexs.length === data.length ? [] : allCheckIndexs);
      return;
    }

    setCheckIndexs((prev) =>
      prev.includes(i) ? prev.filter((index) => index !== i) : [...prev, i],
    );
  };

  return (
    <RoleGuard roles={['TRADER']} isMobile negative>
      <RepairsPage innerScroll>
        <RepairsHeader totalCount={totalCount} onAddRepairClick={onAddRepairClick} />
        <RepairsGroupBody
          setData={setData}
          setTotalCount={setTotalCount}
          checkIndexs={checkIndexs}
          setCheckIndexs={setCheckIndexs}
          handleCheckboxChange={handleCheckboxChange}
          setOnAddRepairClick={setOnAddRepairClick}
        />
      </RepairsPage>
      <RepairCreateInvoiceModal />
      <RepairSetUpdateMultipleModal />
    </RoleGuard>
  );
};
